let isSelected = false; // état global

document.querySelectorAll('path[data-name]').forEach(path => {

    path.addEventListener('click', function () {
        const officeName = this.dataset.name;

        if (!officeName.startsWith("Tracé ")) {
            isSelected = true;
            document.getElementById('dynamic-city-name').textContent = officeName;
        }
    });

    path.addEventListener('mouseenter', function () {
        const officeName = this.dataset.name;

        if (!officeName.startsWith("Tracé ") && !isSelected) {
            document.getElementById('dynamic-city-name').textContent = officeName;
        }
    });
});
